import { Routes, Route, Navigate } from 'react-router-dom';
import Payment from '../pages/Payment/Payment';

const AppRouter = () => (
  <Routes>
    <Route path="/" element={<Navigate to="/payment" />} />
    <Route path="/payment" element={<Payment />} />
  </Routes>
);

export default AppRouter;
